module.exports = "pegasus/assets/themelp1/small/31.png";